import type { SiteStoreWithInit } from '~/stores/site'
import { useSiteStore } from '~/stores/site'
import { useNuxtApp } from '#app'

export default defineNuxtRouteMiddleware(async (to, from) => {
  const siteStore: SiteStoreWithInit = useSiteStore()
  if (!siteStore.initialization) {
    siteStore.initialization = {}
  }

  const config = useRuntimeConfig()
  const { $sanitizeText } = useNuxtApp()
  
  let localeRaw = 'en' // default

  if (to.params.locale) {
    const localeParam =
      Array.isArray(to.params.locale) ? to.params.locale[0] : to.params.locale
    if (localeParam) localeRaw = $sanitizeText(localeParam)
  } else if (to.query.lang) {
    const langQuery =
      Array.isArray(to.query.lang) ? to.query.lang[0] : to.query.lang
    if (langQuery) localeRaw = $sanitizeText(langQuery)
  }

  // Validate format
  if (!/^([a-z]{2,3})(-[A-Z]{2,3})?$/.test(localeRaw)) {
    localeRaw = 'en'
  }

  let collection = ''
  if (config.kontent) {
    collection = config.kontent.collection
  }
  if (to.query.collection && !config.public.isProduction) {
    const collectionQuery =
      Array.isArray(to.query.collection) ? to.query.collection[0] : to.query.collection
    if (collectionQuery) collection = $sanitizeText(collectionQuery)
  }

  siteStore.setCollection(collection)

  if (siteStore.initialization.fetchKontentData === undefined) {
    siteStore.initialization.fetchKontentData = siteStore.fetchData(false, localeRaw)
  }

  try {
    await siteStore.initialization.fetchKontentData
  } catch (error) {
    console.error('Error fetching data:', error)
  }

  siteStore.switchLanguage(localeRaw)
})
